export default "__VITE_ASSET___bAPebWu__"